import React, { useState } from 'react'
import {
	AlertIcon,
	ContactUsIcon,
	LockIcon,
	PackageDowngradeIcon,
	PackageUpgradeIcon,
	RightArrowIcon,
	TickIcon,
} from '../icons'
import { Modal } from '../util'

export const Packages: React.FC = () => {
	const [open, setOpen] = useState<boolean>(false)
	const [
		openSuccessFullUpgradationPopup,
		setOpenSuccessFullUpgradationPopup,
	] = useState<boolean>(false)
	const [
		openNotSuccessFullUpgradationPopup,
		setOpenNotSuccessFullUpgradationPopup,
	] = useState<boolean>(false)

	//handle controls
	const handleOnSuccessHandler = () => {
		setOpen(false)
		setOpenSuccessFullUpgradationPopup(true)
	}
	const handleOnNotSuccessHandler = () => {
		setOpenSuccessFullUpgradationPopup(false)
		setOpenNotSuccessFullUpgradationPopup(true)
	}
	return (
		<div className='packages'>
			<div className='rows'>
				<div className='first-row'>
					<section className='content'>
						<h1>Our Packages</h1>
						<p>Manage your account details, billing information and package.</p>
					</section>
					<img src='./packages-arrow-image.png' alt='packagesimage' />
				</div>
				<div className='second-row'>
					<section className='cards-grid'>
						<section className='starter'>
							<h3>Starter</h3>
							<section className='price'>
								<h1>$50</h1>
								<p>
									<b>/month</b>
								</p>
							</section>
							<section className='features-list'>
								{starterFeaturesList.map((item, i) => (
									<section key={i} className='feature'>
										<TickIcon />
										<h5>
											<b>{item}</b>
										</h5>
									</section>
								))}
							</section>
							<section className='button-section'>
								<button>
									DOWNGRADE <PackageDowngradeIcon />
								</button>
							</section>
						</section>
						<section className='premium'>
							<h3>Premium</h3>
							<section className='price'>
								<h1>$100</h1>
								<p>
									<b>/month</b>
								</p>
							</section>
							<section className='features-list'>
								{premiumFeaturesList.map((item, i) => (
									<section key={i} className='feature'>
										<TickIcon />
										<h5>{item}</h5>
									</section>
								))}
							</section>
							<section className='button-section'>
								<button onClick={() => setOpen(true)}>
									Your package <TickIcon />
								</button>
							</section>
						</section>
						<section className='pro'>
							<h3>Pro</h3>
							<section className='price'>
								<h1>Get in touch!</h1>
							</section>
							<section className='features-list'>
								{proFeaturesList.map((item, i) => (
									<section key={i} className='feature'>
										<TickIcon />
										<h5>{item}</h5>
									</section>
								))}
							</section>
							<section className='button-section'>
								<button>
									Contact us <ContactUsIcon />
								</button>
							</section>
						</section>
					</section>
				</div>
			</div>
			<Modal open={open} onClick={() => setOpen(false)}>
				<section className='updagrade-package-popup'>
					<PackageUpgradeIcon />
					<h1>You are upgrading your package.</h1>
					<p>
						This transaction will be billed and the amount you see in the table
						below will be debited from your account each month.
					</p>
					<section className='data-table'>
						<section className='data-row'>
							<h3>DESCRIPTION</h3>
							<h3>AMOUNT</h3>
						</section>
						<section className='data-row'>
							<h3>Pro Package</h3>
							<h3>$40.00</h3>
						</section>
					</section>
					<section className='button-section'>
						<button onClick={handleOnSuccessHandler}>
							Upgrade
							<RightArrowIcon />
						</button>
					</section>
					<section className='payment-description'>
						<section className='secure-text'>
							<LockIcon />
							<h3>This is a secure SSL encrypted payment</h3>
						</section>
						<img src='./payment-methods.png' alt='paymentmethods' />
					</section>
				</section>
			</Modal>
			<Modal
				open={openSuccessFullUpgradationPopup}
				onClick={() => setOpenSuccessFullUpgradationPopup(false)}>
				<section className='successfull-and-not-upgradation-popup'>
					<img
						src='./successfull-upgradation.png'
						alt='successfull-upgradation'
					/>
					<h1>Upgrade Successful</h1>
					<p>
						Your new download limit will appear on the left menu. Thank you for
						choosing AdCreative.ai
					</p>
					<section className='button-section'>
						<button onClick={handleOnNotSuccessHandler}>
							GO TO PROJECTS <RightArrowIcon />
						</button>
					</section>
				</section>
			</Modal>
			<Modal
				open={openNotSuccessFullUpgradationPopup}
				onClick={() => setOpenNotSuccessFullUpgradationPopup(false)}>
				<section className='successfull-and-not-upgradation-popup'>
					<AlertIcon />
					<h1>Your payment has failed.</h1>
					<p>
						Your account has been automatically deactivated. You’ll need to
						update your payment method to keep using AdCreative and to make sure
						your data is not lost.
					</p>
					<section className='button-section'>
						<button>
							Go to bıllıng <RightArrowIcon />
						</button>
					</section>
				</section>
			</Modal>
		</div>
	)
}

const starterFeaturesList: string[] = [
	'10 Downloads /month',
	'1 Brands',
	'∞ Generates',
]
const premiumFeaturesList: string[] = [
	'100 Downloads /month',
	'∞ Brands',
	'∞ Generates',
	'Beta Features',
]
const proFeaturesList: string[] = [
	'∞ Downloads',
	'∞ Brands',
	'∞ Generates',
	'API Access',
]
